import React from 'react';

function ApplicationFormPanel({section}) {
    return (
        <div>
            {section.ApplicationForm && (
                <>

                            <section.ApplicationForm
                                section={section}
                                open={true}
                                onClose={() => false}
                            />


                </>
            )}
        </div>
    );
}

export default ApplicationFormPanel;